interface Account {
  name: string;
}

interface AuthMock {
  account: Account;
}

export const mockAuth: AuthMock = { account: { name: "Mock User" } };
